import { render, staticRenderFns } from "./PendingStatusChangesGrid.vue?vue&type=template&id=5a8f5370&"
import script from "./PendingStatusChangesGrid.vue?vue&type=script&lang=js&"
export * from "./PendingStatusChangesGrid.vue?vue&type=script&lang=js&"
import style0 from "./PendingStatusChangesGrid.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PendingStatusChangesGrid.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports